import React from "react";
import { WidgetWrap } from "./single-widget";

const WidgetContainer = (props) => {
    const { data } = props;
    return (
        <WidgetWrap
            mrgtop={data.margin ? data.margin.top : data.marginTop}
            mrgbottom={data.margin ? data.margin.bottom : data.marginBottom}
            maxWidth={data.width ? data.width.maxWidth : data.maxWidth}
            minWidth={data.width ? data.width.minWidth : data.minWidth}
            smallScreenOnly={data.smallScreenOnly ?? false}
            fontSize={data.fontSize}
        >
            {props.children}
        </WidgetWrap>
    );
};

export default WidgetContainer;
